export function templateLeadStartedAt(now = Date.now()): number {
    return Math.floor(now / 1_000);
}

export function templateLeadSubmissionSucceeded(response: Pick<Response, "ok">): boolean {
    return response.ok;
}

export function templateLeadSubmissionPayload(
    fields: Record<string, string>,
    metadata: {
        formUuid: string;
        purpose: string;
        honeypotValue: string;
        startedAt: number;
        landingUrl: string;
    },
): Record<string, string | number> {
    return {
        ...fields,
        ...metadata,
    };
}
